<template>
  <!-- updated -->
  <div class="no-result">
    <div class="no-search" v-if="currentType === 'search'">
      <div class="img">
        <img :src="$brandConfig.noSearchResult" />
      </div>
      <div class="text">
        <div class="text1">{{ title }}</div>
        <div class="text2">{{ text }}</div>
      </div>
    </div>
    <div class="no-package" v-else>
      <div class="img" v-if="$brandConfig.showDaishu">
        <!-- <img src="../assets/images/no-result.png"> -->
        <img :src="require('@/assets/images/' + imgUrl + '.png')" />
        <!-- <img :src="imgUrlFile" alt=""> -->
      </div>
      <div class="text">{{ text }}</div>
      <div v-if="tips" class="tips">{{ tips }}</div>
      <div
        class="btn-all-data"
        v-show="currentType == 'package' && btnText && !isWechatSubscription"
        @click="linkAll"
      >
        {{ btnText }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "no-result",
  data() {
    return {
      isWechatSubscription,
    };
  },
  props: {
    btnText: {
      tye: String,
      default: "查看全部套餐",
    },
    text: {
      type: String,
      default: "没有符合条件的套餐",
    },
    tips: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    currentType: {
      type: String,
      default: "",
    },
    imgUrl: {
      type: String,
      default: "no-result",
    },
  },
  mounted() {},

  methods: {
    linkAll() {
      // history.go(0);
      this.$emit("linkAll");
    },
  },
};
</script>

<style lang="less" scoped>
@image: "../assets/images/";
// @import "../assets/css/variable";
.theme-ccb {
  .no-result {
    .no-package {
      .btn-all-data {
        font-size: 36/200rem;
        color: @color-ccb-theme;
        padding: 20/200rem;
        width: 350/200rem;
        border: 1px solid;
        border-radius: 6/200rem;
        margin: 0 auto;
        // margin-top: 90/200rem;
      }
    }
  }
}
.no-result {
  position: relative;
  color: @color-text-l;

  .no-package {
    text-align: center;
    .img {
      margin: 0 auto;
      width: 328/200rem;
      height: 250/200rem;
      img {
        height: 250/200rem;
      }
    }
    .text {
      color: inherit;
      font-size: 30/200rem;
      padding: 50/200rem 0;
      font-weight: inherit;
    }
    .tips {
      color: inherit;
      font-size: 28/200rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }

    .btn-all-data {
      font-size: 36/200rem;
      color: @color-theme;
      padding: 20/200rem;
      width: 350/200rem;
      border: 1px solid;
      border-radius: 6/200rem;
      margin: 0 auto;
      // margin-top: 90/200rem;
    }
  }
  .no-search {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 34/200rem 0;
    .img {
      width: 208/200rem;
      height: 138/200rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      padding-left: 46/200rem;
      .text1 {
        font-size: 30/200rem;
        color: @color-text-d;
        line-height: 50/200rem;
      }
      .text2 {
        font-size: 24/200rem;
        color: @color-text-l;
      }
    }
  }
}
</style>
